module.exports = __webpack_public_path__ + "static/SocialDrop-2-dark-c44c37189702b7d1bb8ed95c6b9585fd.svg";